export default {
  error_messages: {
    failed_to_fetch_orders:
      "Impossible de charger les données. Cliquez sur l'icône « actualiser » ou réessayez dans 1 minute.",
    something_went_wrong: "Une erreur s'est produite, veuillez réessayer.",
  },
};
